export const REFUND_POLICY_TITLE = 'Refund Policy';

export const REFUND_POLICY_INTRO =
  'Echo Jham aims to provide a clear and fair ticketing experience. Refund eligibility depends on the reason for the refund and the status of the event.';

export const REFUND_POLICY_ITEMS = [
  {
    title: 'Event Cancellation',
    body: 'If an event is officially cancelled, eligible ticket holders may receive a full refund of the ticket amount.',
  },
  {
    title: 'Event Postponement',
    body: 'If an event is rescheduled, tickets will generally remain valid for the new date. Eligible users who cannot attend the new date may request a refund within the announced refund period.',
  },
  {
    title: 'Event Changes',
    body: 'Significant changes to the event, such as major venue, date, or event modifications, may qualify for a refund as determined by the event organizer.',
  },
  {
    title: 'Customer-Initiated Cancellation',
    body: 'Purchased tickets are generally non-refundable if the customer simply changes their mind, cannot attend, or arrives late, unless otherwise stated for the specific event.',
  },
  {
    title: 'Duplicate or Incorrect Purchase',
    body: 'Refund requests for accidental duplicate purchases or other purchasing errors may be reviewed on a case-by-case basis.',
  },
  {
    title: 'Refund Requests',
    body: 'Eligible refund requests must be submitted through the designated refund process within the period announced for the event.',
  },
  {
    title: 'Refund Processing',
    body: "Approved refunds will be processed through the original payment method using PayMongo. The time for the refund to appear in the customer's account may vary depending on the payment provider or financial institution.",
  },
  {
    title: 'Service and Processing Fees',
    body: "Any refundable amount, including applicable ticketing, service, or payment fees, will depend on the circumstances of the refund and the specific event's refund terms.",
  },
  {
    title: 'Event-Specific Policies',
    body: 'Some events may have additional refund conditions. These will be clearly displayed before ticket purchase and will apply to that event.',
  },
  {
    title: 'Refund Decision',
    body: 'Refund requests are subject to verification and approval based on this policy and the applicable event-specific terms.',
  },
];
